import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { IUserSettingsEvents, IUserSettingsFields } from '../components/types';
import { UserSettings } from '../components/UserSettings';
import { UserSettingsEvents } from './events';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState,
	): IUserSettingsFields => {
		
		return {
		}
	};
}

const mapDispatchToProps = (
	dispatch: any,
): IUserSettingsEvents => {
	return {
		onLoad: () => dispatch(UserSettingsEvents.onLoad()),
		onClose: () => dispatch(UserSettingsEvents.onClose()),
	}
};

export const UserSettingsHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(UserSettings) as any;

UserSettingsHOC.displayName = 'UserSettingsHOC';
